import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from '../Navigation.less';
import actions from '../actions.js';

export class NavigationBurgerMenu extends React.Component {
  openModal = () => {
    this.props.openMenu();
  };

  render() {
    const { className } = this.props;

    return (
      <div className={`${styles.burger_menu} ${className}`}>
        <button type="button" id="burger-menu" className="padding-none" onClick={this.openModal}>
          <span style={{ fontSize: '2.8rem' }} className="is24-icon-menu-burger-menu" />
        </button>
      </div>
    );
  }
}

NavigationBurgerMenu.propTypes = {
  openMenu: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  openMenu: () => dispatch(actions.openBurgerMenu()),
});

export default connect(null, mapDispatchToProps)(NavigationBurgerMenu);
